module.exports = __webpack_public_path__ + "img/success1.d6b0a141.png";